import script from "./ourBenefit.vue?vue&type=script&setup=true&lang=js"
export * from "./ourBenefit.vue?vue&type=script&setup=true&lang=js"

import "./ourBenefit.vue?vue&type=style&index=0&id=47269a1e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47269a1e"]])

export default __exports__